module.exports = __webpack_public_path__ + "static/media/4.1e85b678.png";